import React from 'react'

// material ui
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// icons
import LearnMoreIcon from 'uno/images/account/icon-learn-more.svg'

// components
import Typography from '@mui/material/Typography'

const StepHeader = ({ modalId, setModal, children, variant }) => {
  const handleClick = event => {
    event.preventDefault()
    setModal({ id: modalId, open: true })
  }

  const typographyVariant = variant || 'h3'

  return (
    <Box my={2} position='relative'>
      <Box position='absolute' right={0} top='-3px'>
        <IconButton onClick={handleClick} size='large'>
          <LearnMoreIcon width='40px' />
        </IconButton>
      </Box>
      <Typography variant={typographyVariant}>{children}</Typography>
    </Box>
  )
}

export default StepHeader
